import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const revertFundingRequestToReview = createApiThunk<void, string>(
  "fundingRequests/revertFundingRequestToReview",
  async (id, { extra: { adminRepository } }) => {
    return adminRepository!.revertFundingRequestToReview(id);
  },
);

export const resetRevertFundingRequestToReview = createAction("fundingRequests/resetRevertFundingRequestToReview");
